const FAVICON_TEXT = (process.env.REACT_APP_FAVICON_TEXT || "")
    .replace(/[^a-z0-9]/gi, "")
    .toUpperCase()
    .slice(0, 3);

const FAVICON_LINK_SELECTOR = "link[data-generated-favicon]";

function removeExistingFavicons() {
    document
        .querySelectorAll("link[rel='icon'], link[rel='shortcut icon'], link[rel='apple-touch-icon']")
        .forEach((node) => node.remove());
}

function createFaviconMarkup(label) {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
            <rect width="64" height="64" rx="14" fill="#111827" />
            <text
                x="32"
                y="33"
                fill="#f9fafb"
                font-family="Arial, sans-serif"
                font-size="${label.length === 3 ? 22 : 26}"
                font-weight="700"
                text-anchor="middle"
                dominant-baseline="middle"
            >${label}</text>
        </svg>
    `.trim();
}

function applyGeneratedFavicon(label) {
    removeExistingFavicons();

    if (!label) {
        return;
    }

    const link = document.querySelector(FAVICON_LINK_SELECTOR) || document.createElement("link");
    link.setAttribute("data-generated-favicon", "true");
    link.rel = "icon";
    link.type = "image/svg+xml";
    link.href = `data:image/svg+xml,${encodeURIComponent(createFaviconMarkup(label))}`;
    document.head.appendChild(link);
}

applyGeneratedFavicon(FAVICON_TEXT);
